import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Il cerca in alto arriva alle pagine con un parametro nell'indirizzo:
 * `?cerca=estintori` precompila il filtro, `?scheda=documenti` apre la scheda
 * giusta. Questo hook lo legge e lo passa alla pagina, e lo rifa' se
 * l'indirizzo cambia mentre la pagina e' gia' aperta: da Sistemi integrati
 * si cerca e si atterra di nuovo su Sistemi integrati, su un'altra scheda.
 */
export function useDaCerca(nome, imposta) {
  const { search } = useLocation();
  useEffect(() => {
    let valore = "";
    try { valore = new URLSearchParams(search).get(nome) || ""; } catch { valore = ""; }
    if (valore) imposta(valore);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, nome]);
}
